import { Tool } from "@/types/tools";
import { HistoryOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";
import { useEffect } from "react";
const buildSidebarRedirect = (): string => {
  return "/changelog";
};
const Render = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace(buildSidebarRedirect());
  }, []);
  return <></>;
};
export default {
  id: "changeLog",
  category: "reference",
  keyPrefix: "reference.changeLog",
  icon: <HistoryOutlined />,
  render: () => <Render />,
  buildSidebarRedirect
} as Tool;